import { formatMoney as shopifyFormat } from '@shopify/theme-currency';
export const getOffset = (element) => {
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }
    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return ({
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
    });
};
export const isValidEmail = (email) => {
    const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(email) === false) {
        return false;
    }
    return true;
};
export const isTouch = typeof document !== 'undefined' && 'ontouchstart' in document.documentElement;
export const isMobile = typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isLinkedinApp = typeof navigator !== 'undefined' && /LinkedInApp/i.test(navigator.userAgent);
export const isIpad = typeof navigator !== 'undefined' && /iPad/i.test(navigator.userAgent);
export const isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
export const isIphone = typeof navigator !== 'undefined' && /iPhone|iPod/i.test(navigator.userAgent);
export const isFirefox = typeof navigator !== 'undefined' && /Firefox|firefox/i.test(navigator.userAgent);
export const isIE11 = typeof window !== 'undefined' && !!window.MSInputMethodContext && !!document.documentMode;
export function getUUID() {
    return Math.round(new Date().getTime());
}
export const formatPrice = (amount, format = window.theme.moneyFormat) => {
    if (typeof amount === 'string' && Number(amount) === undefined) {
        return amount;
    }
    return shopifyFormat(amount, format);
};
export const getUrlParameter = (parameter) => {
    const PageURL = window.location.search.substring(1);
    const URLVariables = PageURL.split('&');
    let ParameterName;
    for (let i = 0; i < URLVariables.length; i++) {
        ParameterName = URLVariables[i].split('=');
        if (ParameterName[0] === parameter) {
            return ParameterName[1] === undefined ? true : decodeURIComponent(ParameterName[1]);
        }
    }
};
